// extracted by mini-css-extract-plugin
export var addViewLink = "_4-2";
export var availabilityIcon = "_4-17";
export var availabilitySelectionIcon = "_4-16";
export var backButton = "_4-3";
export var backIcon = "_4-10";
export var conversationCount = "_4-4";
export var dragHandle = "_4-6";
export var dropdown = "_4-f";
export var dropdownIcon = "_4-8";
export var dropdownOption = "_4-7";
export var dropdownTriangle = "_4-e";
export var expand = "_4-g";
export var folder = "_4-j";
export var folderItem = "_4-d";
export var icon = "_4-9";
export var iconRow = "_4-a";
export var image = "_4-b";
export var logo = "_4-c";
export var navContainer = "_4-i";
export var navigationFooter = "_4-h";
export var pageShell = "_4-0";
export var pageShellWms = "_4-1";
export var placeholderAvailable = "_4-12";
export var placeholderBox = "_4-15";
export var placeholderBusy = "_4-14";
export var placeholderUnavailable = "_4-13";
export var profile = "_4-l";
export var profileContainer = "_4-n";
export var profileDropdown = "_4-o";
export var profileImage = "_4-m";
export var profileMain = "_4-p";
export var profileSubtitle = "_4-r";
export var profileTitle = "_4-q";
export var reorderIcon = "_4-s";
export var sentLine = "_4-v";
export var settingsHeader = "_4-t";
export var sidenavTextColor = "_4-z";
export var spamLine = "_4-u";
export var subitemWithTag = "_4-5";
export var supportItems = "_4-k";
export var teamText = "_4-11";
export var viewLine = "_4-y";
export var viewLineButton = "_4-x";
export var viewLineButtons = "_4-w";